import { callService, callServicePost, callServiceDelete } from "./service";
const url_base = "form";

export const getCategoria = async () => {
    return await callService(`${url_base}/categorias`);
};
export const getTipoDenuncia = async () => {
    return await callService(`${url_base}/tipoDenuncia`);
};
export const getTipoRelacion = async () => {
    return await callService(`${url_base}/tipoRelacion`);
};
export const getTextosConfig = async () => {
    return await callService(`${url_base}/textosConfig`);
};
export const getCodeConsulta = async() => {
    return await callService(`${url_base}/GetCodeConsulta`)
}
export const getComplaintByCode = async (code, password) => {
    return await callService(`${url_base}/GetComplaintByCode/${code}/${password}`);
};
export const setDenunciaComment = async (code, message, fromManager) => {
    return await callService(
      `${url_base}/SetDenunciaComment/${code}/${message}/${fromManager}`,
      {
        method: "POST",
        body: JSON.stringify({ code, message, fromManager }),
        headers: {
          "Content-Type": "application/json",
        },
      },
      false,
      false
    );
};
export const ChangePassword = async (code, password, newPassword) => {
    return await callService(
      `${url_base}/ChangePassword/${code}/${password}/${newPassword}`,
      {
        method: "POST",
        body: JSON.stringify({ code, password, newPassword }),
        headers: {
          "Content-Type": "application/json",
        },
      },
      false,
      false
    );
};

export const sePuedeCambiarPassword = async (code, password) => {
  return await callService(`${url_base}/sePuedeCambiarPassword/${code}/${password}`);
};
export const setDocumento = async (documento) => {
  return await callService(
    `${url_base}/documento`,
    {
      method: "POST",
      data: documento,
    },
    false,
    false
  );
};